import Loader from "components/Loader/loader"
import React, { useEffect, useState } from "react"
import { FaSave } from "react-icons/fa"
import { FaCircleXmark } from "react-icons/fa6"
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import Swal from "sweetalert2"
import { fetchData, FetchPutData } from "utils/Common_api_functions"

const Donation = ({ isopen, onclose }) => {
  const [loading, setLoading] = useState(false)
  const [id, setId] = useState("")
  const [amount, setAmount] = useState("")

  useEffect(() => {
    getDiscountAmount()
  }, [])

  async function getDiscountAmount() {
    const APIdata = await fetchData(setLoading, "donation")
    if (APIdata?.success) {
      setId(APIdata?.data?._id)
      setAmount(APIdata?.data?.amount)
    }
  }

  const handleUpdate = async () => {
    const APIdata = await FetchPutData(setLoading, "donation", id, { amount })
    if (APIdata?.data?.success) {
      getDiscountAmount()
      Swal.fire({
        title: "Donation Amount Updated Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
    } else {
      Swal.fire({
        title: "Error Updating Donation Amount.",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <Modal isOpen={isopen} centered>
      {loading && <Loader />}
      <ModalHeader toggle={() => onclose()}>Donation Amount</ModalHeader>
      <ModalBody>
        <Label>Donation Price (For Global LeaderBoard)</Label>
        <Input
          className="form-control"
          value={amount}
          onChange={e => {
            const value = e.target.value.replace(/[^0-9]/g, "")
            setAmount(value)
          }}
        />
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-primary" onClick={() => handleUpdate()}>
          <FaSave /> Update
        </Button>
        <Button className="btn-danger" onClick={() => onclose()}>
          <FaCircleXmark /> Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default Donation
